module.exports = __webpack_public_path__ + "img/shiba-loading.cf668fa8.png";